import styled from 'styled-components';
import tw from 'twin.macro';

export const CommonImageClass =
  'rounded-lg w-full object-contain object-center';

export const BodyAttachmentSizeClass = 'max-h-full max-w-full sm:w-25 sm:h-20';

export const PreviewIconWrapper = styled.div`
  ${tw`w-12 h-12 sm:w-28 sm:h-28`}
`;
